import { MotionProps } from 'framer-motion';
import { TOP_BAR_TRANSITION_DURATION_SEC } from '../BaseTabPanel/constants';

const DEFAULT_ANIMATION_STATE = {
  opacity: 0,
};

export const regeneratingViewAnimationProps: MotionProps = {
  transition: {
    duration: TOP_BAR_TRANSITION_DURATION_SEC,
  },
  initial: DEFAULT_ANIMATION_STATE,
  animate: {
    opacity: 1,
  },
  exit: DEFAULT_ANIMATION_STATE,
};
